import React, { useEffect, useState } from "react";
import styles from "./Player.module.css";
import usePlayerSeat from "@/src/hooks/data/usePlayerSeat";
import { 
  useGameDefinition,
  usePlayerSeat as useGamePlayerSeat,
  useIsWinnerDeclared,
  useWinningPotDisplay,
  useMultiPotAmounts,
  useGameStage,
  usePlayerSitOutTimer,
  useIsGameStarted,
  useGameId
} from "@/src/hooks/data/useGameTable";
import BorderTimer from "./BorderTimer";
import OpponentCards from "../OpponentCards/OpponentCards";
import PlayerPositionIcon from "../PlayerPositionIcon/PlayerPositionIcon";
// import PlayerAvatar from "../PlayerAvatar/PlayerAvatar";
import { PlayerAvatar } from "@themed-components";
// import PlayerDetails from "../PlayerDetails/PlayerDetails";
import { PlayerDetails } from '@themed-components';
// import ClientCards from "../ClientCards/ClientCards";
import { ClientCards } from '@themed-components';
// import PlayerBet from "../PlayerBet/PlayerBet";
import { PlayerBet } from '@themed-components';
// import PlayerLastAction from "../PlayerLastAction/PlayerLastAction";
import { PlayerLastAction } from '@themed-components';
import { ACTIVE, ACTIVE_G } from "@/Poker/data/Constants";
import PlayerBackCards from "../PlayerBackCards/PlayerBackCards";

export default function Player({ tempTableId, position, clientChairIndex }) {
  const {
    displayName,
    userName,
    atTableAmount,
    avatar,
    tableTimer,
    activeTableTimerType,
    lastAction,
    betAmount,
    playerTurn,
    isFolded,
    cards,
    revealCard,
    possibleWinningHandType,
    winningAmount,
    isWinner,
    isSmallBlind,
    isBigBlind,
    isDealer,
    sitOutOption,
    playerStatus,
    isTakenSeat,
    isActive,
    bountyAmount,
  } = usePlayerSeat(tempTableId, position);

  const gameDefinition = useGameDefinition(tempTableId);
  const playerSeat = useGamePlayerSeat(tempTableId);
  const isWinnerDeclared = useIsWinnerDeclared(tempTableId);
  const winningPotDisplay = useWinningPotDisplay(tempTableId);
  const multiPotAmounts = useMultiPotAmounts(tempTableId);
  const gameStage = useGameStage(tempTableId);
  const playerSitOutTimer = usePlayerSitOutTimer(tempTableId);
  const isGameStarted = useIsGameStarted(tempTableId);
  const gameId = useGameId(tempTableId);

  const returnPlayerScaling = () => {
    if (position === playerSeat) {
      return 1;
    }
    switch (gameDefinition.maxPlayers) {
      case 2:
        return 1;
      case 4:
        return 1;
      case 6:
        return 1;
      case 8:
      case 9:
        return 0.9;
    }
  };

  const isSeatedOut = sitOutOption;
  const isActivePlayer = (playerSeat === position && playerSitOutTimer) || sitOutOption
    ? false
    : userName && isTakenSeat
      ? isFolded
        ? false
        : isActive
          ? true
          : false
      : true;

  const isPlayerInactive = !isActivePlayer;

  return (
    <div
      id={"test-player"}
      className={`${styles.playerContainer}`}
      style={{ transform: `scale(${returnPlayerScaling()})` }}
    >
      <PlayerAvatar
        tempTableId={tempTableId}
        position={position}
        isFolded={isFolded}
        isWinner={isWinner}
        isWinnerDeclared={isWinnerDeclared}
        winningPotDisplay={winningPotDisplay}
        multiPotAmounts={multiPotAmounts}
        tableTimer={tableTimer}
        userName={userName}
        isSeatedOut={isSeatedOut}
        isInactive={isPlayerInactive}
      />
      <OpponentCards
        tempTableId={tempTableId}
        clientChairIndex={clientChairIndex}
        playerSeat={playerSeat}
        position={position}
        cards={cards}
        revealCard={revealCard}
        isInactive={isPlayerInactive}
      />
      {/* Player Back Cards */}
      <PlayerBackCards
        maxPlayers={gameDefinition.playersPerTable ?? gameDefinition.maxPlayers}
        clientChairIndex={clientChairIndex}
        gameDefinition={gameDefinition}
        playerSeat={playerSeat}
        position={position}
        isSeatedOut={isSeatedOut}
        isInactive={isPlayerInactive}
        isGameStarted={isGameStarted}
        isFolded={isFolded}
        revealCard={revealCard}
        gameId={gameId}
      />

      {/* Dealer Icon, SB Icon, BB Icon */}
      <PlayerPositionIcon
        clientChairIndex={clientChairIndex}
        maxPlayers={gameDefinition.playersPerTable ?? gameDefinition.maxPlayers}
        isSmallBlind={isSmallBlind}
        isBigBlind={isBigBlind}
        isDealer={isDealer}
        isSeatedOut={isSeatedOut}
        gameDefinition={gameDefinition}
        isInactive={isPlayerInactive}
      />
      <div className={styles.timerWrapper}>
        <PlayerDetails
          displayName={displayName}
          userName={userName}
          atTableAmount={atTableAmount}
          winningAmount={winningAmount}
          isFolded={isFolded}
          isSeatedOut={isSeatedOut}
          isInactive={isPlayerInactive}
          gameDefinition={gameDefinition}
          bountyAmount={bountyAmount}
        />
        <PlayerLastAction
          clientChairIndex={clientChairIndex}
          activePlayer={tableTimer}
          lastAction={lastAction}
          betAmount={betAmount}
          maxPlayers={gameDefinition.playersPerTable ?? gameDefinition.maxPlayers}
          isWinnerDeclared={isWinnerDeclared}
          gameStage={gameStage}
          isSeatedOut={isSeatedOut}
          isInactive={isPlayerInactive}
        />
        {/* SVG border timer */}
        <BorderTimer key={activeTableTimerType} timer={tableTimer} />
      </div>
      {/* Logged in player cards */}
      <ClientCards
        possibleWinningHandType={possibleWinningHandType}
        position={position}
        tempTableId={tempTableId}
        scale={1}
      />
      {/* Player Last Action Components (Bets) */}
      <PlayerBet
        clientChairIndex={clientChairIndex}
        lastAction={lastAction}
        betAmount={betAmount}
        maxPlayers={gameDefinition.playersPerTable ?? gameDefinition.maxPlayers}
        isWinnerDeclared={isWinnerDeclared}
        gameStage={gameStage}
        isInactive={isPlayerInactive}
      />
    </div>
  );
}
